import { useMemo } from 'react';

export const useTransformMetadata = ({ metadata, t }) => {
  return useMemo(
    () => metadata.map((el) => ({ ...el, title: t(el.title) })),
    [t, metadata],
  );
};
